import React, { useState } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    List,
    Typography,
} from "@mui/material";
import {
    AccountBalanceWalletRounded,
    AddRounded,
    HistoryRounded,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import _UserCreditListItem from "./_UserCreditListItem";
import _UserAddCreditModal from "./_UserAddCreditModal";

const _UserCredits = ({ corporatePersonnel, updatePage }) => {
    const corporate = useSelector(({ corporate }) => corporate.corporate);
    const credits = corporatePersonnel?.CreditList || [];
    const [openAddModal, setOpenAddModal] = useState(false);

    return (
        <>
            <Card
                elevation={0}
                sx={{
                    borderRadius: 4,
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                    boxShadow: '0 2px 14px rgba(0, 0, 0, 0.03)',
                    overflow: 'hidden'
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        p: 2,
                        px: 2.5,
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 1.5,
                        bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.015)'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
                        <HistoryRounded sx={{ color: 'primary.main', fontSize: 22 }} />
                        <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                            تاریخچه و جزئیات اعتبارات پرسنل
                        </Typography>
                        <Chip
                            icon={<AccountBalanceWalletRounded sx={{ fontSize: 16 }} />}
                            label={`${credits.length} بسته اعتباری`}
                            size="small"
                            variant="outlined"
                            sx={{ fontWeight: 700, borderRadius: 2 }}
                        />
                    </Box>

                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<AddRounded />}
                        onClick={() => setOpenAddModal(true)}
                        sx={{
                            borderRadius: 2.5,
                            fontWeight: 700,
                            px: 2,
                            boxShadow: '0 4px 12px rgba(28, 139, 156, 0.25)',
                        }}
                    >
                        تخصیص اعتبار جدید
                    </Button>
                </Box>

                <CardContent sx={{ p: 2 }}>
                    {credits.length > 0 ? (
                        <List disablePadding sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            {credits.map((item) => (
                                <_UserCreditListItem
                                    key={item.Id}
                                    userCredit={item}
                                    updatePage={updatePage}
                                />
                            ))}
                        </List>
                    ) : (
                        <Box sx={{ textAlign: 'center', py: 5 }}>
                            <Box
                                sx={{
                                    width: 56,
                                    height: 56,
                                    borderRadius: '50%',
                                    bgcolor: 'rgba(28, 139, 156, 0.08)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mx: 'auto',
                                    mb: 1.5,
                                    color: 'primary.main'
                                }}
                            >
                                <AccountBalanceWalletRounded sx={{ fontSize: 28 }} />
                            </Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 0.5 }}>
                                اعتباری یافت نشد
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 2 }}>
                                تاکنون اعتبار به این کارمند اختصاص نیافته است.
                            </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<AddRounded />}
                                onClick={() => setOpenAddModal(true)}
                                sx={{ borderRadius: 2.5, fontWeight: 700 }}
                            >
                                اولین اعتبار را تخصیص دهید
                            </Button>
                        </Box>
                    )}
                </CardContent>
            </Card>

            {/* Modal: تخصیص اعتبار به کارمند */}
            <_UserAddCreditModal
                open={openAddModal}
                onClose={() => setOpenAddModal(false)}
                corporatePersonnel={corporatePersonnel}
                corporate={corporate}
                onSuccess={updatePage}
            />
        </>
    );
};

export default _UserCredits;
